import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface PeriodicElement {
    position: number;
    campaign_name: string;
    start_date: string;
    end_date: string;
    last_modified: string;
    created_on: string;
    industry: string;
    status: string;
}

@Component({
    selector: 'app-campaign-overview',
    templateUrl: './campaign-overview.component.html',
    styleUrls: ['./campaign-overview.component.scss']
})
export class CampaignOverviewComponent implements OnInit {
    /** table  **/
    public ELEMENT_DATA: PeriodicElement[] = [
        {
            position: 1,
            campaign_name: 'Inifiniti QX60',
            start_date: '02-01-2020',
            end_date: '02-06-2020',
            last_modified: '15-05-2020',
            created_on: '30-12-2019',
            industry: 'Cars',
            status: 'completed'
        }
    ];

    displayedColumns: string[] = [
        'position',
        'campaign_name',
        'start_date',
        'end_date',
        'last_modified',
        'created_on',
        'industry',
        'status'
    ];
    dataSource = new MatTableDataSource<PeriodicElement>(this.ELEMENT_DATA);

    constructor() {}

    ngOnInit() {}
}
